import React from 'react'

const reasons = [
  {
    icon: '✦',
    title: 'Clean, professional finishes',
    desc: 'Every job is completed to the highest standard of craft and care.',
  },
  {
    icon: '◈',
    title: 'Skilled, experienced team',
    desc: 'Our team brings years of hands-on expertise to every project.',
  },
  {
    icon: '◉',
    title: 'Transparent pricing',
    desc: 'No hidden costs or surprises — just honest, upfront quotes.',
  },
  {
    icon: '◷',
    title: 'Reliable timelines',
    desc: 'We commit to schedules and follow through, every time.',
  },
]

const styles = {
  section: {
    backgroundColor: '#f9f7f4',
    padding: '10px 24px',
    fontFamily: "'Georgia', serif",
  },
  inner: {
    maxWidth: '1100px',
    margin: '0 auto',
  },
  topRow: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    marginBottom: '52px',
    gap: '24px',
    flexWrap: 'wrap',
  },
  tag: {
    display: 'inline-block',
    fontSize: '11px',
    fontFamily: "'Helvetica Neue', sans-serif",
    fontWeight: '500',
    letterSpacing: '0.14em',
    textTransform: 'uppercase',
    color: '#8b6f47',
    marginBottom: '14px',
  },
  heading: {
    fontSize: 'clamp(28px, 5vw, 44px)',
    fontWeight: '400',
    color: '#1a1a1a',
    margin: '0',
    lineHeight: '1.15',
    fontFamily: "'Georgia', serif",
  },
  subtext: {
    fontSize: '15px',
    color: '#666',
    maxWidth: '280px',
    lineHeight: '1.7',
    margin: '0',
    fontFamily: "'Helvetica Neue', sans-serif",
    fontWeight: '400',
    alignSelf: 'flex-end',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
    gap: '2px',
    backgroundColor: '#e8e0d6',
  },
  card: {
    backgroundColor: '#f9f7f4',
    padding: '36px 28px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    transition: 'background-color 0.25s ease',
    cursor: 'default',
  },
  cardHoverBg: '#fff',
  iconWrap: {
    fontSize: '22px',
    color: '#8b6f47',
    lineHeight: '1',
  },
  cardTitle: {
    fontSize: '16px',
    fontWeight: '500',
    color: '#1a1a1a',
    margin: '0',
    fontFamily: "'Helvetica Neue', sans-serif",
    lineHeight: '1.3',
  },
  cardDesc: {
    fontSize: '13px',
    color: '#777',
    margin: '0',
    lineHeight: '1.65',
    fontFamily: "'Helvetica Neue', sans-serif",
  },
  wideCard: {
    backgroundColor: '#1a1a1a',
    padding: '36px 28px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    gridColumn: '1 / -1',
  },
  wideIcon: {
    fontSize: '22px',
    color: '#c9a96e',
    lineHeight: '1',
  },
  wideTitle: {
    fontSize: '16px',
    fontWeight: '500',
    color: '#fff',
    margin: '0',
    fontFamily: "'Helvetica Neue', sans-serif",
  },
  wideDesc: {
    fontSize: '13px',
    color: '#999',
    margin: '0',
    lineHeight: '1.65',
    fontFamily: "'Helvetica Neue', sans-serif",
  },
}

function WhyChooseUs() {
  const [hovered, setHovered] = React.useState(null)

  return (
    <section style={styles.section}>
      <div style={styles.inner}>
        <div style={styles.topRow}>
          <div>
            <span style={styles.tag}>Our promise</span>
            <h2 style={styles.heading}>Why choose us</h2>
          </div>
          <p style={styles.subtext}>
            Here's what sets us apart and why clients keep coming back.
          </p>
        </div>

        <div style={styles.grid}>
          {reasons.map((r, i) => (
            <div
              key={i}
              style={{
                ...styles.card,
                backgroundColor: hovered === i ? styles.cardHoverBg : styles.card.backgroundColor,
              }}
              onMouseEnter={() => setHovered(i)}
              onMouseLeave={() => setHovered(null)}
            >
              <span style={styles.iconWrap}>{r.icon}</span>
              <p style={styles.cardTitle}>{r.title}</p>
              <p style={styles.cardDesc}>{r.desc}</p>
            </div>
          ))}

          <div style={styles.wideCard}>
            <span style={styles.wideIcon}>⬡</span>
            <p style={styles.wideTitle}>Installation & material supply — all in one</p>
            <p style={styles.wideDesc}>
              We handle everything end-to-end, so you don't have to coordinate multiple suppliers. One team, one call, zero stress.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default WhyChooseUs;